import { WidgetProps } from '@rjsf/utils';
import React from 'react';
import { DescriptionWidget } from '../components/ViewWidget/DescriptionWidget';

const TextWidget: React.FC<WidgetProps> = ({ disabled, uiSchema }) => {
  if (disabled) {
    return null;
  }

  return <DescriptionWidget uiSchema={uiSchema}></DescriptionWidget>;
};

export default TextWidget;
